import { useMandatorContext, MandatorType } from "@rentablo/theming";
import { ComponentType, ReactNode } from "react";

export function useBlockExtender<P extends object>(
  config: Partial<Record<MandatorType, ComponentType<P>>>,
  props: P
): ReactNode {
  const { mandatorSlug } = useMandatorContext();
  const Component = config[mandatorSlug];
  return Component ? <Component {...props} /> : null;
}

export function useHasBlockExtender(
  config: Partial<Record<MandatorType, unknown>>
): boolean {
  const { mandatorSlug } = useMandatorContext();
  return Boolean(config[mandatorSlug]);
}
